import React, { useState, useEffect } from 'react';
import { fetchCalendar } from '../utils/api';
import './Calendar.css';

const Calendar = () => {
    const [date, setDate] = useState(new Date());
    const [days, setDays] = useState([]);
    const [hoveredDay, setHoveredDay] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        fetchCalendar(year, month)
            .then(response => {
                setDays(response.data.days || []);
            })
            .catch(error => {
                console.error('Error fetching calendar data:', error);
            });
    }, [date]);

    const renderDays = () => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDayOfMonth = new Date(year, month, 1).getDay();
        const lastDateOfMonth = new Date(year, month + 1, 0).getDate();

        let daySquares = [];

        for (let i = 0; i < firstDayOfMonth; i++) {
            daySquares.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
        }

        for (let i = 1; i <= lastDateOfMonth; i++) {
            const dayData = days && days.find(d => d.day === i);
            daySquares.push(
                <div 
                    key={i} 
                    className={`calendar-day ${dayData ? 'has-events' : ''}`}
                    onMouseEnter={(e) => dayData && handleDayMouseEnter(dayData, e)}
                    onMouseLeave={handleDayMouseLeave}
                >
                    {i}
                </div>
            );
        }
        return daySquares;
    };

    const handlePrevMonth = () => {
        setDate(new Date(date.getFullYear(), date.getMonth() - 1, 1));
    };

    const handleNextMonth = () => {
        setDate(new Date(date.getFullYear(), date.getMonth() + 1, 1));
    };

    const handleDayMouseEnter = (day, e) => {
        setHoveredDay(day);
        setTooltipPosition({ x: e.clientX, y: e.clientY });
    };

    const handleDayMouseLeave = () => {
        setHoveredDay(null);
    };

    return (
        <div className="calendar-container">
            <div className="calendar-header">
                <button onClick={handlePrevMonth}>&lt;</button>
                <h2>{date.toLocaleString('default', { month: 'long', year: 'numeric' })}</h2>
                <button onClick={handleNextMonth}>&gt;</button>
            </div>
            <div className="calendar-weekdays">
                <div>Sun</div>
                <div>Mon</div>
                <div>Tue</div>
                <div>Wed</div>
                <div>Thu</div>
                <div>Fri</div>
                <div>Sat</div>
            </div>
            <div className="calendar-grid">
                {renderDays()}
            </div>
            {hoveredDay && hoveredDay.entities.length > 0 && (
                <div
                    className="calendar-tooltip"
                    style={{ left: tooltipPosition.x, top: tooltipPosition.y }}
                >
                    {hoveredDay.entities.map((entity, index) => (
                        <div key={index}>
                            <strong>{entity.type.name}</strong>
                            {entity.data.student && (
                                <p>{entity.data.student.first_name} {entity.data.student.last_name}</p>
                            )}
                            {entity.data.agent && (
                                <p>{entity.data.agent.name}</p>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Calendar;
